export { default as NutritionInformation } from './nutrition-information';
export { default as SodiumFlag } from './sodium-flag';
